var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewShipment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.44 1.59 4.36 6.17.75 4.42 9.67.08c.2-.1.44-.1.65 0zM19.25 4.42l-9.24 4.51-3.46-1.68-.5-.25 9.09-4.58.5.25zM9.26 15.4a8.568 8.568 0 0 0 0 4.18v.14L.41 15.17A.76.76 0 0 1 0 14.5V5.72l3.75 1.82v3.2c0 .41.34.75.75.75s.75-.34.75-.75V8.28l.5.24 3.52 1.71zM20.01 9.38C19.22 9.13 18.37 9 17.5 9c-2.74 0-5.18 1.3-6.73 3.32v-2.1L20 5.73c.01.84.01 2.48.01 3.65zM17.5 11c-3.58 0-6.5 2.92-6.5 6.5s2.92 6.5 6.5 6.5 6.5-2.92 6.5-6.5-2.92-6.5-6.5-6.5zm2.75 7.25h-2v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2h-2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2v-2c0-.41.34-.75.75-.75s.75.34.75.75v2h2c.41 0 .75.34.75.75s-.34.75-.75.75z",
    fill: "#fff",
    opacity: 1,
    "data-original": "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewShipment);
export default __webpack_public_path__ + "static/media/newShipment.b448e426db02aab0f881654c6fc5dc9b.svg";
export { ForwardRef as ReactComponent };